import { DiagramRoute } from './diagramRoute'
import { EntityRoute } from './entityRoute'
import { FormRoute } from './formRoute'
import { SearchAssistantRoute } from './searchAssistantRoute'
import { TimelineRoute } from './timelineRoute'
import { WindowRoute } from './windowRoute'

export type RouteType = 'form' | 'entity' | 'diagram' | 'search-assistant' | 'timeline' | 'window'

export const createRouteStrategy = (type: RouteType) => {
  switch (type) {
    case 'form':
      return new FormRoute()
    case 'entity':
      return new EntityRoute()
    case 'diagram':
      return new DiagramRoute()
    case 'search-assistant':
      return new SearchAssistantRoute()
    case 'timeline':
      return new TimelineRoute()
    case 'window':
      return new WindowRoute()
    default:
      throw new Error(`Unknown route type: ${type}`)
  }
}
